<template>
  <div v-if="selectedProduct">
    <md-dialog
      :md-active="formShow"
      style="width: 80%; max-width: 100%; overflow: auto;"
      class="md-scrollbar"
    >
      <div class="table-data__tool mb-1">
        <md-dialog-title class="able-data__tool-left">{{ formTitle }}</md-dialog-title>
      </div>

      <md-content class="md-scrollbar" style="max-height: 500px;">
        <template v-if="loading">
          <div class="d-flex justify-content-center align-items-center" style="min-height: 150px; ">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
          </div>
        </template>
        <template v-else>
          <fieldset :disabled="formMode === 'view'">
            <form action method="post" enctype="multipart/form-data" class="form-horizontal p-3">
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="vendor_project_id" class="form-control-label" v-required>Ref No</label>
                </div>
                <div class="col-12 col-md-9">
                  <select
                    id="vendor_project_id"
                    name="vendor_project_id"
                    placeholder
                    class="form-control"
                    ref="vendor_project_id"
                    v-model="input.vendor_project_id"
                  >
                    <option
                      v-for="vendorProject in vendorProjects"
                      :value="vendorProject.id"
                      :key="vendorProject.id"
                    >{{vendorProject.ref_no}}</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="stock_date" class="form-control-label">Stock Date</label>
                </div>
                <div class="col-12 col-md-9">
                  <datePicker
                    v-model="input.stock_date"
                    :config="{format: 'YYYY-MM-DD HH:mm:ss',useCurrent: false, showClear: true}"
                  ></datePicker>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="type" class="form-control-label">Type</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="radio"
                    name="type"
                    id="type_IN"
                    value="IN"
                    v-model="input.type"
                    class="mr-1"
                  >
                  <label for="type_IN" class="mr-1">Stock In</label>
                  <input
                    type="radio"
                    name="vendor_specsheet"
                    id="type_OUT"
                    value="OUT"
                    v-model="input.type"
                    class="mr-1"
                  >
                  <label for="type_OUT">Stock Out</label>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="stock" class="form-control-label">Stock Quantity</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="stock"
                    name="stock"
                    placeholder
                    class="form-control"
                    v-model="input.stock"
                  >
                </div>
              </div>
            </form>
          </fieldset>
          <md-dialog-actions>
            <md-button class="md-primary" @click="save()" v-if="formMode != 'view'">Save</md-button>
            <md-button class="md-primary" @click="$emit('closeSampleStockEditForm')">Cancel</md-button>
          </md-dialog-actions>
        </template>
      </md-content>
    </md-dialog>
  </div>
</template>

<script>

import SampleStockModel from './model/SampleStock.js'
import datePicker from 'vue-bootstrap-datetimepicker';

export default {
  name: 'SampleStockEdit',
  components: {
    datePicker
  },
  props: {
    formMode: String,
    formShow: Boolean,
    selectedProduct: Object,
    selectedSampleStock: Object,
  },
  data() {
    return {
      input: SampleStockModel,
      datas: null,
      loading: false,
      pageType: null,
      vendorProjects: []
    }
  },
  computed: {
    formTitle: function () {
      if (this.selectedProduct)
        return 'Stock In / Stock Out'
    },
  },
  watch: {
    formShow() {
      this.getVendorProject()
      this.input.product_id = this.selectedProduct.id
    },
    selectedSampleStock: function (data) {
      if (data) {
        this.$http
          .get(this.WebService.samplestock + '/' + data.id)
          .then((res) => {
            this.input = res.data.data
          })
      } else {
        this.input = SampleStockModel
      }
    },
  },
  methods: {
    getVendorProject() {
      this.$http
        .get(this.WebService.product + '/' + this.selectedProduct.id + '/vendorproject')
        .then((res) => {
          this.vendorProjects = res.data.data
        })
        .catch((err) => {

        })
        .finally(null)
    },
    save() {
      if (this.input.id) {
        this.$http
          .put(this.WebService.samplestock + '/' + this.input.id, this.input)
          .then((res) => {
            this.$emit('closeSampleStockEditForm')
            this.$emit('reload')
          })
          .catch((err) => {
            this.$emit('alertBar', {
              type: 'danger',
              title: 'Failed',
              content: err.data.message,
            })
          })
      } else {
        this.$http
          .post(this.WebService.samplestock, this.input)
          .then((res) => {
            this.$emit('closeSampleStockEditForm')
            this.$emit('reload')
          })
          .catch((err) => {
            this.$emit('alertBar', {
              type: 'danger',
              title: 'Failed',
              content: err.data.message,
            })
          })
      }
    },
  }
}
</script>
<style scoped>
.md-content {
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
}
</style>
